import { Platform } from "react-native";
var useNewWebImplementation = true;
var getWasCalled = false;
export function enableExperimentalWebImplementation() {
    var _shouldEnable = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
// NO-OP since the new implementation is now the default
}
export function enableLegacyWebImplementation() {
    var shouldUseLegacyImplementation = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    if (Platform.OS !== "web" || useNewWebImplementation === !shouldUseLegacyImplementation) {
        return;
    }
    if (getWasCalled) {
        console.error("Some parts of this application have already started using the new gesture handler implementation. No changes will be applied. You can try enabling legacy implementation earlier.");
        return;
    }
    useNewWebImplementation = !shouldUseLegacyImplementation;
}
export function isNewWebImplementationEnabled() {
    getWasCalled = true;
    return useNewWebImplementation;
}
